import { Input } from "reactstrap";

export const columns = [
    {
        name: "Name",
        minWidth: "180px",
        selector: (row) => row.name,
        cell: (row) => (
            <div
                className="d-flex justify-content-left align-items-center"
                onClick={() => row.onCellClick(row._id)}
            >
                <div className="d-flex flex-column">
                    <p className="user_name text-truncate text-body">
                        <span className="fw-bolder">
                            {row.name || "Anonymous"}
                        </span>
                    </p>
                </div>
            </div>
        ),
    },
    {
        name: "Address",
        minWidth: "150px",
        selector: (row) => row.account,
        cell: (row) => (
            <div
                className="d-flex justify-content-left align-items-center"
                onClick={() => row.onCellClick(row._id)}
            >
                <p className="text-truncate text-body">
                    <span className="fw-bolder">{`${row.account.slice(
                        0,
                        5
                    )}...${row.account.slice(-6)}`}</span>
                    <br />
                </p>
            </div>
        ),
    },
    {
        name: "# of contracts",
        minWidth: "150px",
        selector: (row) => row.contracts,
        cell: (row) => (
            <div
                className="d-flex justify-content-left align-items-center"
                onClick={() => row.onCellClick(row._id)}
            >
                <p className="text-truncate text-body">
                    <span className="fw-bolder">{row.contracts}</span>
                    <br />
                </p>
            </div>
        ),
    },
    {
        name: "# of tokens",
        minWidth: "150px",
        selector: (row) => row.tokens,
        cell: (row) => (
            <div
                className="d-flex justify-content-left align-items-center"
                onClick={() => row.onCellClick(row._id)}
            >
                <p className="text-truncate text-body">
                    <span className="fw-bolder">{row.tokens}</span>
                    <br />
                </p>
            </div>
        ),
    },
    {
        name: "Batch mint",
        minWidth: "150px",
        selector: (row) => row.batchMint,
        cell: (row) => (
            <div className="d-flex justify-content-left align-items-center">
                <div className="form-switch mb-2 ps-0">
                    <Input
                        style={{
                            marginLeft: 0,
                            width: "45px",
                            cursor: "pointer",
                        }}
                        type="switch"
                        name="isBatch"
                        checked={row.batchMint}
                        onChange={() => row.setBatchMint(!row.batchMint)}
                    />
                </div>
            </div>
        ),
    },
    {
        name: "Own Pinata",
        minWidth: "150px",
        selector: (row) => row.isOwnPinata,
        cell: (row) => (
            <div className="d-flex justify-content-left align-items-center">
                <div className="form-switch mb-2 ps-0">
                    <Input
                        style={{
                            marginLeft: 0,
                            width: "45px",
                            cursor: "pointer",
                        }}
                        type="switch"
                        name="isOwnPinata"
                        checked={row.isOwnPinata}
                        onChange={() => row.setOwnPinata(!row.isOwnPinata)}
                    />
                </div>
            </div>
        ),
    },
];
